import { theme } from 'modules/ui';
import styled from 'styled-components';
import { mediaQuery } from 'modules/utils';
import { Link } from 'react-router-dom';
import { SocialLinks } from '../social-links';

export const StyledFooterLinksContainer = styled.div`
  width: 100%;
  min-height: 5.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const StyledLinkList = styled.ul`
  list-style-type: none;
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  ${mediaQuery('md')} {
    flex-direction: row;
  }

  margin: 0;
  padding: 0;
  width: 100%;

  li {
    margin: 0;
    padding: 0.8rem;
    border-top: 1px solid ${({theme}) => theme.colors.primaryK4};

    &:first-child {
      padding-top: 2rem;
      border: none;
    }

    &:last-child {
      border-bottom: 1px solid ${({theme}) => theme.colors.primaryK4};
    }

    ${mediaQuery('md')} {
      border-top: 0;

      &:first-child {
        padding-top: 0.8rem;
      }

      &:last-child {
        border-bottom: 0;
      }
    }
  }
`;



export const StyledFooterLink = styled(Link)`
    color: ${({theme}) => theme.colors.primaryK3};
    cursor: pointer;
    font-size: var(--h4-font-size);
    text-decoration: var(--text-underline);
    
    &:hover {
      color: ${({theme}) => theme.colors.primaryK1};
        text-decoration: var(--text-underline);
    }

    padding-left: 0;

    ${mediaQuery('md')} {
      padding-left: 0;
    }
  
    a {
      color: ${({theme}) => theme.colors.primaryK3};
      cursor: pointer;
      font-size: var(--h4-font-size);
      
      &:hover {
        color: ${({theme}) => theme.colors.primaryK1};
      }

        padding-left: 0;

      ${mediaQuery('md')} {
        padding-left: 0;
      }
    }
`;

export const StyledSocialLinks = styled(SocialLinks)`
  ${mediaQuery('md')} {
    display: none;
  }

  margin: 2.9rem 0;
`;
